import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {
  ENDPOINT_PERMISSION_TYPE
} from '../../../../../config/constants';
import { endpointBasicInformationPropTypes } from '../proptypes/EndpointPropTypes';

const EndpointBasicInformationResource = ({
  id, name, description, route, permissionType
}) => (
  <>
    <ResourceProperty label="Nombre del Punto de Acceso:">{name}</ResourceProperty>
    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>
    <ResourceProperty label="Ruta:">
      {route || '-'}
    </ResourceProperty>
    <ResourceProperty label="Tipo de Permiso:">
      {permissionType ? ENDPOINT_PERMISSION_TYPE[permissionType].label : '-'}
    </ResourceProperty>
  </>
);

EndpointBasicInformationResource.propTypes = endpointBasicInformationPropTypes;

export default EndpointBasicInformationResource;
